import {HttpClient} from '@angular/common/http';
import {PathService} from '../../login/services/path.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FileService {

    private baseUrl: string = '';

    constructor(protected http: HttpClient, private pathService: PathService) {
        this.baseUrl = `${pathService.hostServerBackOffice}/files`;
    }

    /**
     * Get file by its name
     * @param: fileName
     */
    public getFileByName(fileName: string): Observable<any> {
        return this.http.get(`${this.baseUrl}/${fileName}`, {
            responseType: 'blob', observe: 'body'
        });
    }

    public uploadCategoryFile(file: File): Observable<string> {
        const formData = new FormData();
        formData.set('file', file);
        return this.http.post<string>(`${this.baseUrl}/upload/category`, formData);
    }

    public uploadPartnerFile(file: File): Observable<string> {
        const formData = new FormData();
        formData.set('file', file);
        return this.http.post<string>(`${this.baseUrl}/upload/partner`, formData);
    }

    public uploadAndUpdatePartnerFile(file: File, uuid: string): Observable<string> {
        const formData = new FormData();
        formData.set('file', file);
        return this.http.post<string>(`${this.baseUrl}/upload-update/partner?uuid=${uuid}`, formData);
    }

    public uploadOfferFile(file: File): Observable<string> {
        const formData = new FormData();
        formData.set('file', file);
        return this.http.post<string>(`${this.baseUrl}/upload/offer`, formData);
    }

    public uploadPubFile(file: File): Observable<string> {
        const formData = new FormData();
        formData.set('file', file);
        return this.http.post<string>(`${this.baseUrl}/upload/pub`, formData);
    }
}
